
import RentalClubShowVue from '../components/rental_clubs/RentalClubShow.vue';
import Vue from 'vue';

Vue.component('rental-club-show', RentalClubShowVue);

export default Vue.extend({});
